import { render, staticRenderFns } from "./bankCardManagement.vue?vue&type=template&id=a8dbdb64&scoped=true"
import script from "./bankCardManagement.vue?vue&type=script&lang=js"
export * from "./bankCardManagement.vue?vue&type=script&lang=js"
import style0 from "./bankCardManagement.vue?vue&type=style&index=0&id=a8dbdb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dbdb64",
  null
  
)

export default component.exports